// extracted by mini-css-extract-plugin
export var colorSquare = "_rx-0";
export var danger = "_rx-5";
export var lightPink = "_rx-8";
export var neutralBlue = "_rx-7";
export var neutralYellow = "_rx-6";
export var normal = "_rx-1";
export var primary = "_rx-2";
export var primaryLight = "_rx-3";
export var solidBlack = "_rx-g";
export var solidGreen = "_rx-b";
export var solidLightBlue = "_rx-d";
export var solidNavy = "_rx-c";
export var solidOrange = "_rx-f";
export var solidPink = "_rx-e";
export var solidRed = "_rx-9";
export var solidYellow = "_rx-a";
export var success = "_rx-4";